import { EventTrackingProps } from "@/types/common";
import { WarningCircular } from "@monsterindia/global-ui-components";
import React from "react";

import ProfileHiddenBtn from "@/components/common/profileHiddenBtn";

import { getPersonal } from "./query";

interface ProfileVisibilityNudgeProps {
  handleEventTracking?: (event: EventTrackingProps) => void;
  pageName?: string;
}

const ProfileVisibilityNudge: React.FC<ProfileVisibilityNudgeProps> = ({
  handleEventTracking,
  pageName,
}) => {
  const { data = null, isLoading } = getPersonal();
  const profileVisibility =
    data?.personalDetailSection?.personalDetails?.profileVisibility;

  if (isLoading || profileVisibility) {
    return null;
  } else {
    handleEventTracking &&
      handleEventTracking({
        eventType: "eventPush",
        eventName: "profile_visibility_banner_shown",
        eventProps: { page_name: pageName ?? "" },
      });
  }

  return (
    <div className="pt-4 md:pt-6" id="profile-visibility-nudge">
      <div className="bg-state-surface-error-bold text-state-content-inverse mx-3 flex max-w-[1188px] flex-col items-start justify-between gap-3 rounded-lg p-3 md:container md:mx-0 md:flex-row md:items-center">
        <span className="flex items-center gap-2 text-sm">
          <span className="flex-1">
            <WarningCircular width={24} height={24} />
          </span>
          Your profile is hidden from recruiters. Unhide now to appear in
          recruiter searches and unlock top opportunities.
        </span>
        <ProfileHiddenBtn
          customClassName="text-content-primary ml-8 w-[124px] text-sm font-semibold"
          modifier="primary-white"
          handleEventTracking={handleEventTracking}
          pageName={pageName}
        />
      </div>
    </div>
  );
};

export default ProfileVisibilityNudge;
